import type {
  OrderFormConfig,
  OrderFormField,
} from "@web-app/pages/settings/FormBuilderTab/types";
import http from "@web-app/utils/http";

export const getOrderFormConfig = () =>
  http
    .get<OrderFormConfig>("/currentWorkspace/orderFormConfig")
    .then((r) => r.data);

export const updateOrderFormConfig = (fields: OrderFormField[]) =>
  http
    .put<OrderFormConfig>("/currentWorkspace/orderFormConfig", { fields })
    .then((r) => r.data);
